import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const SubEventHeader = ({ reloadEventList, parentEventTitle }) => {
  const { t } = useTranslation(); //for translation
  const breadCrumbText = [
    { title: t("Event"), link: "/admin/events/list" },
    { title: t("Sub Events") },
  ];
  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            displayName={parentEventTitle}
            top={false}
          />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={reloadEventList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}
        </div>
      </div>
    </div>
  );
};

export default SubEventHeader;
